<template>
  <div class="high-talent-panel">
    <div class="panel-title">高层次人才</div>
    <div class="summary-box">
      <div class="summary-icon">
        <img src="@/assets/images/rencai-count.png" alt="人才"/>
      </div>
      <div class="summary-info">
        <div class="summary-label">人才总量</div>
        <div class="summary-total">{{ gccrc.configValue }}<span class="summary-total-unit">人</span></div>
      </div>
      <img src="@/assets/images/nan.png" alt="男"/>

      <div class="summary-gender">
        <div class="gender-row">
          <span class="male-label">{{ sexData.man.configName }}</span>
          <span class="male-value">{{ sexData.man.configValue }}人</span>
        </div>
        <div class="gender-bar">
          <div class="male-bar" :style="{ width: sexData.man.remark }"></div>
          <div class="female-bar" :style="{ width: sexData.woman.remark }"></div>
        </div>
        <div class="gender-row-nv">
          <span class="female-label">{{ sexData.woman.configName }}</span>
          <span class="female-value">{{ sexData.woman.configValue }}人</span>
        </div>
      </div>
      <img src="@/assets/images/nv.png" alt="女" style="margin-left: 10px;"/>

    </div>
    <div class="charts-row">
      <div class="chart-box">
        <div class="chart-title2">
          <img src="@/assets/images/title_line.png" alt="年龄" style="margin-right: 5px;"/>
          年龄分布
        </div>
        <div ref="ageChart" class="chart-content" style="margin-left: 10px;"></div>
      </div>
      <div class="chart-box">
        <div class="chart-title2">
          <img src="@/assets/images/title_line.png" alt="年龄" style="margin-right: 5px;"/>
          人才层次
        </div>
        <div
            style="display: flex;flex-direction: column;background: white;border-radius: 4px;padding-left: 10px;padding-right: 10px;padding-top: 5px;padding-bottom: 5px;">

          <div class="card1" v-for="item in rencaiList" :key="item.name">
            <img :src="item.img" alt="B类" style="width: 21px;height: 21px;margin-left: 10px;"/>
            <span style="margin-left: 10px;font-size: 14px;color: black;flex: 1;">{{ item.name }}</span>
            <span style="font-size: 16px;text-align: right;margin-right: 15px;">{{ item.value }}人</span>
          </div>
        </div>
      </div>
    </div>
    <div class="charts-row">
      <div class="chart-box">
        <div class="chart-title">
          <div>
            <img src="@/assets/images/title_line.png" alt="年龄"/>
            行业分布
          </div>

          <span class="chart-title-unit">单位：人</span>
        </div>
        <div ref="domainChart" class="chart-content" style="margin-left: 10px;"></div>
      </div>
      <div class="chart-box">
        <div class="chart-title">
          <div>
            <img src="@/assets/images/title_line.png" alt="年龄"/>
            学历层次
          </div>
          <span class="chart-title-unit">单位：人</span>
        </div>
        <div class="edu-progress-list">
          <div class="edu-progress-item" v-for="item in eduList" :key="item.name">
            <div class="edu-label">{{ item.name }}</div>
            <div class="edu-bar-row">
              <div class="edu-bar-bg">
                <div class="edu-bar-fg" :style="{
                  width: (item.value / maxEdu * 100) + '%',
                  background: item.color
                }"></div>
              </div>
              <div class="edu-value">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import rencai1 from '../assets/images/rencai_1.png'
import rencai3 from '../assets/images/rencai_3.png'
import rencai4 from '../assets/images/rencai_4.png'
import rencai5 from '../assets/images/rencai_5.png'


export default {
  name: 'HighLevelTalentPanel',
  props: {
    dataObject: {
      type: Object,
      required: true
    }
  },
  watch: {
    dataObject: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          // 数据已更新，可以在这里更新图表
          this.$nextTick(() => {
            this.updateCharts()
          })
          this.refreshTimer = setInterval(() => {
            this.initAgeChart()
          }, 8000);
          this.refreshTimer = setInterval(() => {
            this.initDomainChart()
          }, 7000);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    // 每隔6秒刷新统计图

  },


  created() {
  },
  data() {
    return {
      rencaiList: [],
      eduList: [
        {name: '专科', value: 332684, color: 'linear-gradient(90deg, #ff914d, #ffd28d)'},
        {name: '本科', value: 512384, color: 'linear-gradient(90deg, #4d8aff, #8fd3ff)'},
        {name: '硕士及以上', value: 166544, color: 'linear-gradient(90deg, #3edfa7, #a8ffce)'}
      ],
      gccrc: {},
      sexData: {
        man: {},
        woman: {}
      },
      ageData: {
        titleList: [],
        dataList: [],
      },
      cengciData: {
        titleList: [],
        dataList: [],
      },
      domainData: {
        titleList: [],
        dataList: [],
      },
      ageChartInstance: null,
      levelChartInstance: null,
      domainChartInstance: null,
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    if (this.ageChartInstance) {
      this.ageChartInstance.dispose();
    }
    if (this.levelChartInstance) {
      this.levelChartInstance.dispose();
    }
    if (this.domainChartInstance) {
      this.domainChartInstance.dispose();
    }
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  },
  computed: {
    maxEdu() {
      return Math.max(...this.eduList.map(i => i.value)) * 1.1;
    }
  },
  methods: {
    updateCharts() {
      if (!this.dataObject) {
        return
      }

      this.rencaiList = this.dataObject.children[4].children.map((item, index) => {
        return {
          name: item.configName,
          value: parseInt(item.configValue),
          img: this.getrencaiImg(index)
        }
      })
      this.gccrc = this.dataObject.children[0]
      this.sexData = {
        man: this.dataObject.children[1],
        woman: this.dataObject.children[2]
      }
      this.ageData = {
        titleList: this.dataObject.children[3].children.map(item => item.configName),
        dataList: this.dataObject.children[3].children.map(item => {
          return {
            name: item.configName,
            value: parseInt(item.configValue.replace("%", "")),
            itemStyle: {
              color: this.getColor(item.configName)
            }
          }
        })
      }
      this.cengciData = {
        titleList: this.dataObject.children[4].children.map(item => item.configName + ' ' + item.configValue),
        dataList: this.dataObject.children[4].children.map(item => {
          return {
            name: item.configName + ' ' + item.configValue,
            value: parseInt(item.configValue.replace("%", "")),
            itemStyle:
                {color: this.getCengciColor(item.configName), borderColor: '#fff', borderWidth: 4, borderRadius: 10}
          }
        })
      }
      this.domainData = {
        titleList: this.dataObject.children[5].children.map(item => item.configName),
        dataList: this.dataObject.children[5].children.map(item => parseInt(item.configValue))
      }
      this.eduList = this.dataObject.children[6].children.map(item => {
        return {
          name: item.configName,
          value: parseInt(item.configValue),
          color: this.geteduColor(item.configName)
        }
      })
      console.log("值" + JSON.stringify(this.domainData))
      // 更新所有图表
      this.initAgeChart()
      this.initLevelChart()
      this.initDomainChart()
    },
    geteduColor(name) {
      if (name === '大学专科') {
        return 'linear-gradient(90deg, #ff914d, #ffd28d)'
      }
      if (name === '大学本科') {
        return 'linear-gradient(90deg, #4d8aff, #8fd3ff)'
      }
      if (name === '硕士研究生') {
        return 'linear-gradient(90deg, #3edfa7, #a8ffce)'
      }
      if (name === '博士研究生') {
        return 'linear-gradient(274deg, #D611CC 6%, #FF5DF7 100%)'
      }

    },
    getColor(index) {
      if (index === '20-35周岁') {
        return "#ff914d"
      } else if (index === '36-45周岁') {
        return "#ff5ca2"
      } else if (index === '46-55周岁') {
        return "#3edfa7"
      } else if (index === '56岁以上') {
        return "#4d8aff"
      } else {
        return "#ff914d"
      }
    },
    getrencaiImg(index) {
      if (index === 0) {
        return rencai1
      } else if (index === 1) {
        return rencai3
      }
      if (index === 2) {
        return rencai4
      }
      if (index === 3) {
        return rencai5
      }
    },
    getCengciColor(index) {
      if (index === 0) {
        return '#3edfa7'
      } else if (index === 1) {
        return '#ffb74d'
      } else if (index === 2) {
        return '#4d8aff'
      } else if (index === 3) {
        return '#5cc2ff'
      } else {
        return '#3edfa7'
      }
    },
    chartInit(el) {
      const dpr = Math.min(Math.max(window.devicePixelRatio || 1, 1), 2.5)
      return echarts.init(el, null, {
        renderer: 'svg',
        devicePixelRatio: dpr
      })
    },
    chartFont() {
      return {
        fontFamily: 'PingFang SC, Microsoft YaHei, Helvetica Neue, Arial, sans-serif'
      }
    },
    initAgeChart() {
      if (!this.$refs.ageChart) return;
      if (this.ageChartInstance) {
        this.ageChartInstance.dispose();
      }
      this.ageChartInstance = this.chartInit(this.$refs.ageChart);
      const font = this.chartFont()
      this.ageChartInstance.setOption({
        tooltip: { trigger: 'item' },
        legend: {
          bottom: 0,
          left: 'center',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#111',
            fontSize: 14,
            ...font
          },
          data: this.ageData.titleList
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            center: ['50%', '40%'],
            label: {
              show: true,
              position: 'outside',
              formatter: function (params) {
                return Math.round(params.percent) + '%'
              },
              color: '#111',
              fontSize: 15,
              ...font
            },
            labelLine: {
              show: true,
              length: 6,
              length2: 12,
              lineStyle: { color: '#333', width: 1.5 }
            },
            data: this.ageData.dataList
          }
        ]
      });
    },
    initLevelChart() {
      if (!this.$refs.levelChart) return;
      if (this.levelChartInstance) {
        this.levelChartInstance.dispose();
      }
      this.levelChartInstance = this.chartInit(this.$refs.levelChart);
      const showData = this.cengciData.dataList[2]; // 默认显示C类
      const font = this.chartFont()
      const setCenterText = (d) => ({
        type: 'text',
        left: 'center',
        top: '38%',
        style: {
          text: `${d.value}%`,
          textAlign: 'center',
          fontSize: 17,
          fontFamily: font.fontFamily,
          fill: d.itemStyle.color
        }
      });
      this.levelChartInstance.setOption({
        tooltip: {show: false},
        legend: {
          bottom: 0,
          left: 'center',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#2d3a50',
            fontSize: 14,
            ...this.chartFont()
          },
          data: this.cengciData.titleList
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '55%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            label: {show: false},
            labelLine: {show: false},
            data: this.cengciData.dataList
          }
        ],
        graphic: setCenterText(showData)
      });
      this.levelChartInstance.on('click', (params) => {
        if (params.seriesType === 'pie') {
          this.levelChartInstance.setOption({
            graphic: setCenterText(params.data)
          });
        }
      });
    },
    initDomainChart() {
      if (!this.$refs.domainChart) return;
      if (this.domainChartInstance) {
        this.domainChartInstance.dispose();
      }
      this.domainChartInstance = this.chartInit(this.$refs.domainChart);
      const colors = [
        '#ff5ca2', '#ff914d', '#3edfa7', '#4d8aff', '#b36cff', '#ff4c4c', '#ffd700', '#00bcd4', '#ff9800', '#9c27b0'
      ];
      const font = this.chartFont()
      this.domainChartInstance.setOption({
        grid: {
          left: 78,
          right: 28,
          top: 20,
          bottom: 20
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            color: '#111',
            fontSize: 13,
            margin: 10,
            show: false,
            ...font,
            formatter: function (value) {
              return value >= 1000 ? (value / 1000).toFixed(1) + 'k' : value;
            }
          },
          axisLine: { show: true, lineStyle: { color: '#A7DDFDFF' } },
          splitLine: { show: true }
        },
        yAxis: {
          type: 'category',
          data: this.domainData.titleList,
          axisLabel: {
            color: '#111',
            fontSize: 14,
            margin: 12,
            ...font
          },
          axisLine: { lineStyle: { color: '#A7DDFDFF' } },
          axisTick: { show: false }
        },
        series: [{
          type: 'bar',
          data: this.domainData.dataList.map((value, index) => ({
            value: value,
            itemStyle: {
              color: colors[index % colors.length]
            }
          })),
          itemStyle: {
            borderRadius: [0, 8, 8, 0]
          },
          barWidth: 16,
          label: {
            show: true,
            position: 'right',
            fontSize: 14,
            color: '#111',
            ...font,
            formatter: function (params) {
              return params.value >= 1000 ? (params.value / 1000).toFixed(1) + 'k' : params.value;
            }
          }
        }]
      });
    },
    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        if (this.ageChartInstance) {
          this.ageChartInstance.resize();
        }
        if (this.levelChartInstance) {
          this.levelChartInstance.resize();
        }
        if (this.domainChartInstance) {
          this.domainChartInstance.resize();
        }
      }, 100);
    }
  },
}
</script>

<style scoped>
.high-talent-panel {
  background-image: url('@/assets/images/icon-rencai_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 10px;
  padding-bottom: 10px;
}

.panel-title {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  margin-bottom: 12px;
  padding-left: 20px;
  background-image: url('@/assets/images/icon-rencai.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.summary-box {
  display: flex;
  align-items: center;
  margin: 10px 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #F0F9FF;
  border-radius: 4px 4px 4px 4px;
}

.chart-title-unit {
  font-family: Alibaba PuHuiTi 2.0;
  font-size: 13px;
  font-weight: normal;
  color: black;
}

.summary-icon img {
  width: 48px;
  height: 48px;
}

.summary-info {
  margin-left: 10px;
  margin-right: 16px;
}

.summary-label {
  font-size: 14px;
  color: #282828CC;
}

.summary-total {
  font-size: 28px;
  color: #164166FF;
  font-weight: bold;
}

.summary-total-unit {
  font-size: 14px;
  color: #282828CC;
}

.summary-gender {
  flex: 1;
  margin-left: 10px;
}

.gender-row {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #fff;
  margin-bottom: 2px;
}

.male-label {
  color: #1B77FFFF;
  margin-right: 4px;
}

.male-value {
  color: #1B77FFFF;
  margin-right: 4px;
  font-weight: bold;
}

.male-icon {
  color: #3fa7ff;
}

.female-label {
  color: #FF23FEFF;
  margin-left: 8px;
  font-weight: bold;
}

.female-value {
  color: #FF23FEFF;
}

.gender-bar {
  width: 100%;
  height: 8px;
  background: #e0e6f6;
  border-radius: 4px;
  margin-bottom: 2px;
  display: flex;
  overflow: hidden;
}

.male-bar {
  background: #3fa7ff;
  height: 100%;
}

.female-bar {
  background: #ff5ca2;
  height: 100%;
}

.gender-row-nv {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #fff;
  margin-bottom: 2px;
  justify-content: flex-end;
}

.charts-row {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.chart-box {
  flex: 1;
  display: flex;
  width: 50%;
  padding-right: 10px;
  flex-direction: column;
}

.chart-title {
  font-size: 14px;
  padding-left: 10px;
  color: #282828FF;
  margin-bottom: 2px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #282828;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 10px;
}

.chart-title2 {
  font-size: 14px;
  padding-left: 10px;
  color: #282828FF;
  margin-bottom: 2px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  color: #282828;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 10px;
}

.chart-content {
  height: 180px;
  background: #F3FAFF;
  border-radius: 4px 4px 4px 4px;
}

.level-legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  margin-top: 8px;
  width: 100%;
  color: #333;
  gap: 8px 12px;
}

.edu-progress-list {
  height: 180px;
  background: #F3FAFF;
  border-radius: 4px 4px 4px 4px;
}

.edu-progress-item {
  margin-left: 10px;
  margin-top: 5px;
}

.edu-label {
  font-size: 13px;
  color: black;
  margin-bottom: 2px;
}

.edu-bar-row {
  display: flex;
  width: 100%;
  align-items: center;
}

.edu-bar-bg {
  height: 8px;
  width: 100%;
  background: #e0e6f6;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 12px;
  position: relative;
}

.edu-bar-fg {
  height: 100%;
  border-radius: 6px;
  transition: width 0.4s;
}

.edu-value {
  font-size: 13px;
  color: black;
  font-weight: bold;
  margin-right: 20px;
  text-align: left;
}

.card1 {
  background: #DFF1FF;
  width: 100%;
  height: 37px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #1774FF;
}

.card1-title {
  display: flex;
  justify-content: center;
  color: #1774FF;
}
</style>
